import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import DeliveryInformationComponent from "../DeliveryInformationComponent/DeliveryInformationComponent";
import SelectProductComponent from "../SelectProductsComponent/SelectProductComponent";
import SelectProviderComponent from "../SelectProviderComponent./SelectProviderComponent";

const CommonOrderInfosComponent = ({
    allProducts,
    deliveryInformationsRef,
    productsRef,
    providerRef,
    selectedIsRentingRef,
    noProduct,
    setNoProduct,
    badQuantity,
    setBadQuantity,
    cannotSend,
    initComment,
    onValidateCommon
}) => {

    const [comment, setComment] = useState(initComment || '');

    return <>
        <DeliveryInformationComponent deliveryInformationsRef={deliveryInformationsRef} isToSetCommonInfos={true} />
        <SelectProductComponent allProducts={allProducts} productsRef={productsRef} setNoProduct={setNoProduct}
            setBadQuantity={setBadQuantity} noProduct={noProduct} badQuantity={badQuantity} cannotSend={cannotSend}
            isToSetCommonInfos={true} selectedIsRentingRef={selectedIsRentingRef}/>
        <SelectProviderComponent providerRef={providerRef} />
        <Row>
            <Col>Commentaire :
                <textarea
                style={{width:'100%'}}
                type="text"
                placeholder="un commentaire ?"
                value={comment} onChange={(e) => {setComment(e.target.value);}} />
            </Col>
        </Row>
        <Row >
            <Col className="mt-3 d-flex align-items-center justify-content-center">
                <Button variant= "success" onClick={()=>{onValidateCommon(comment)}}>Valider</Button>
            </Col>
        </Row>
    </>;
}

export default CommonOrderInfosComponent;
